import {
  LOBBY_GET_PARAMS_SUCCESS,
  LOBBY_GET_PARAMS_FAILURE,
  LOBBY_GET_PARAMS,
  LOBBY_GET_LANGUAGES_FAILURE,
  LOBBY_GET_LANGUAGES,
  LOBBY_GET_LANGUAGES_SUCCESS,
} from "@shared/constants";
import { languageService } from "@shared/services/LanguageService/LanguageService";
import { post, checkResponse } from "@shared/utils/server";
import { put, call, fork, takeLatest, all } from "redux-saga/effects";

export function* getParams() {
  try {
    const response = yield call(post, {
      method: "Lobby.getParams",
      args: {},
    });

    checkResponse(response);

    yield put({
      type: LOBBY_GET_PARAMS_SUCCESS,
      payload: response[0],
    });
  } catch (err) {
    yield put({
      type: LOBBY_GET_PARAMS_FAILURE,
      payload: err,
    });
  }
}

export function* getLanguages() {
  try {
    const response = yield languageService.fetchLanguages();
    checkResponse(response);

    yield put({
      type: LOBBY_GET_LANGUAGES_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: LOBBY_GET_LANGUAGES_FAILURE,
      payload: err,
    });
  }
}

function* watchGetParams() {
  yield takeLatest(LOBBY_GET_PARAMS, getParams);
}

function* watchGetLanguages() {
  yield takeLatest(LOBBY_GET_LANGUAGES, getLanguages);
}

export default function* lobby() {
  yield all([fork(watchGetParams), fork(watchGetLanguages)]);
}
